// =============================================================================
//  Copyright : 2023 semantics GmbH
//  Date      : $Date: 2024-02-15 09:32:11 +0100 (Thu, 15 Feb 2024) $
//  Author    : Olli Powroznik
//  Worker    : $Author: o.powroznik $
//  Revision  : $Rev: 140538 $
//  Purpose   : custom buttons
// =============================================================================
// ---Third-party imports
import React from 'react'
import clsx from 'clsx'

// ---Framework imports
import log from 'uix/logging'
import {VIcon} from 'graphics'

// ---Local imports
import S from './button.scss'

// ---Exports
export const Button = ({
  disabled,
  circle = true,
  size = 'normal',
  onClick,
  content,
  icon,
  className,
  bordered,
  children,
  style,
  inverted,
}) => {
  let sizes = {
    mini: 'mini',
    tiny: 'tiny',
    small: 'small',
    normal: 'normal',
    large: 'large',
    huge: 'huge',
    giant: 'giant',
  }[size]

  let iconSizes = {
    mini: 'mini',
    tiny: 'tiny',
    small: 'tiny',
    normal: 'small',
  }[size]

  return (
    <div
      onClick={onClick}
      className={clsx(
        className,
        S.button,
        inverted && S.inverted,
        sizes && S[size],
        circle && S.circle,
        disabled && S.disabled,
        bordered && S.bordered,
        icon && S.icon
      )}
      style={style}
    >
      {content || children}
      {icon && (
        <VIcon style={{textShadow: 'none'}} size={iconSizes ? iconSizes : undefined} name={icon} />
      )}
    </div>
  )
}

export const ButtonGroup = ({children, vertical = false, style, floated, gap = '.3em'}) => {
  //filter empty children
  let childrn = children.filter(child => child !== undefined)
  return (
    <div
      className={clsx(
        S.buttonGroup,
        !vertical && S.horizontal,
        floated === 'right' && S.floatRight
      )}
      style={style}
    >
      {childrn.map((child, i) => {
        let gapStyle = gap ? {marginRight: `${gap}`} : null
        if (childrn.length - 1 === i) {
          gapStyle = null
        }
        if (child) {
          return (
            <div key={i} style={gapStyle}>
              {child}
            </div>
          )
        }
      })}
    </div>
  )
}
